<template>
  <div>
    <div class="title">
      <p>{{ this.$store.state.titles }}</p>
    </div>
    <div class="main">
      <div class="ContentTitle_box">
        <div class="ContentTitle">
          <div class="ContentTitle_name">素材中心</div>
          <div class="TotalCapacity">
            总容量 <span style="margin-left:16px">{{ TotalCapacity }}</span>
          </div>
          <div class="CurrentCapacity">
            <span style="width:80px;text-align:right">当前容量</span>
            <el-progress :percentage="percentage" color="#2448FF" :show-text="false" style="width:480px;height:4px;margin-left:16px;"></el-progress>
            <span style="margin-right:8px;margin-left:8px">{{ CurrentCapacity }}</span> /<span style="margin-left:8px">{{ TotalCapacity }}</span>
          </div>
        </div>
      </div>
      <div class="ContentTitle_Bot">
        <div class="ContentTitle_Left">
          <div class="Video_ification">视频分组</div>
          <div style="margin-left:24px"><el-button type="warning" size="mini" @click="UpdataVidoe">上传视频</el-button></div>
          <!-- 上传视频的弹框 -->
          <UpDataDloaing ref="upDataef" :openUndata="openUndata"></UpDataDloaing>
          <!-- 分类的弹框 -->
          <el-dialog :title="labelName" :visible.sync="ClassificationBool">
            <el-form>
              <el-form-item label="分类名称" label-width="120px">
                <el-input v-model="Classification" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="ClassificationClick">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 删除的弹框 -->
          <el-dialog title="删除分类" :visible.sync="ClassificationDel">
            <div style="margin-left:50px">
              <div style="margin-bottom:30px">确认删除所选分类组吗？</div>
              <div>
                <el-radio v-model="Deleteradio" label="1">仅解除分组</el-radio>
                <div style="margin-left:24px;color:#666;height:50px;line-height:50px">仅解除分组，组内全部视频将自动归人未分组</div>
                <el-radio v-model="Deleteradio" label="2">删除分组全部内容</el-radio>
                <div style="margin-left:24px;color:#666;height:50px;line-height:50px">请谨慎删除：将导致线上视频无法访问，腾出素材空间将在此日重新恢复</div>
              </div>
            </div>
            <el-dialog title="提示" :visible.sync="ClassTwoDel" append-to-body>
              <div style="margin-left:50px">
                <div style="margin-bottom:30px">删除该视频会导致线上无法访问，请谨慎操作！</div>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="NoClassTwoDelClick">取 消</el-button>
                <el-button type="primary" @click="ClassTwoDelClick">确 定</el-button>
              </div>
            </el-dialog>
            <div slot="footer" class="dialog-footer">
              <el-button @click="NoClassDeletClick">取 消</el-button>
              <el-button type="primary" @click="ClassDeletClick">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 分类数组 -->
          <div class="ification_box">
            <ul>
              <li v-for="(item, index) in classificaList" :key="index" class="ification">
                <div>{{ item.name }}</div>
                <div v-if="item.id !== 0">
                  <el-dropdown @command="handleCommand(item)" trigger="click">
                    <i class="el-icon-more el-dropdown-link"> </i>
                    <el-dropdown-menu>
                      <el-dropdown-item @click.native="append('编辑')">编辑</el-dropdown-item>
                      <el-dropdown-item @click.native="append('删除')">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </li>
            </ul>
          </div>
          <div style="margin-left:24px;margin-top:30px"><el-button type="primary" size="mini" @click="AddClassit">添加分类</el-button></div>
        </div>
        <div class="ContentTitle_right">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column align="center" prop="image_url" label="视频" width="150">
              <template slot-scope="scope">
                <img :src="scope.row.image_url" alt="" style="width:36px;height:36px" />
              </template>
            </el-table-column>
            <el-table-column align="center" prop="size" label="大小" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.size < 1024">{{ scope.row.size.toFixed(2) }}B</span>
                <span v-else-if="scope.row.size / 1024 < 1024">{{ (scope.row.size / 1024).toFixed(2) }}KB</span>
                <span v-else-if="scope.row.size / 1024 / 1024 < 1024">{{ (scope.row.size / 1024 / 1024).toFixed(2) }}MB</span>
                <span v-else-if="scope.row.size / 1024 / 1024 / 1024 < 1024">{{ (scope.row.size / 1024 / 1024 / 1024).toFixed(2) }} GB</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="upload_time" label="上传时间" width="300"> </el-table-column>
            <el-table-column align="center" prop="city" label="上传状态" width="120">
              <template slot-scope="scope">
                <div v-if="scope.row.identify_status">
                  {{ scope.row.identify_status == 1 ? "上传中" : scope.row.identify_status == 3 ? "上传失败，鉴黄机审不通过" : "上传成功" }}
                </div>
                <div v-else-if="scope.row.release_status && scope.row.identify_status == 2">
                  {{ scope.row.release_status == 1 ? "待发布" : "待审核" }}
                </div>
                <div v-else-if="scope.row.audit_status && scope.row.release_status == 2">
                  {{ scope.row.audit_status == 1 ? "待审核" : scope.row.audit_status == 2 ? "审核成功" : scope.row.audit_status == 3 ? "审核失败" : "-" }}
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="goods_count" label="关联商品" width="120"> </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-link
                  style="margin:0 3px;"
                  v-if="scope.row.identify_status == 1 || (scope.row.release_status == 2 && scope.row.audit_status == 1)"
                  @click="handleClick(scope.row)"
                  type="primary"
                  size="small"
                  >详情</el-link
                >
                <el-link style="margin:0 3px;" v-if="scope.row.identify_status == 2 && scope.row.release_status == 1" @click="handleRelease(scope.row)" type="success" size="small">发布</el-link>
                <span v-if="scope.row.identify_status == 3 || (scope.row.identify_status == 2 && scope.row.release_status == 1) || scope.row.audit_status == 3">
                  <el-link style="margin:0 3px;" @click="handleDelet(scope.row)" type="danger" size="small">删除</el-link>
                </span>
                <el-link style="margin:0 3px;" v-if="scope.row.release_status == 2 && scope.row.audit_status == 1" @click="handleUndoPublishing(scope.row)" type="warning" size="small"
                  >撤销发布</el-link
                >
                <el-link
                  style="margin:0 3px;"
                  v-if="scope.row.identify_status == 3 || (scope.row.identify_status == 2 && scope.row.release_status == 1) || scope.row.audit_status == 2"
                  @click="handleDetail(scope.row)"
                  type="warning"
                  size="small"
                  >编辑</el-link
                >
                <el-link style="margin:0 3px;" v-if="scope.row.audit_status == 3" @click="handleDetail(scope.row)" type="info" size="small">原因</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              @size-change="sizeChange"
              @current-change="handleSizeChange"
              background
              :current-page="page"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UpDataDloaing from "./common/Dolading.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { UpDataDloaing },
  data() {
    return {
      TotalCapacity: "", //总容量
      CurrentCapacity: "", //当前容量
      percentage: 0, //进度条的百分比
      classificaList: [{ name: "我伍六七", id: 1 }], //分类的数组
      tableData: [], //文件列表数组
      total: 0, //当前文件总条数
      page: 1, //当前页数
      limit: 10, //每页多少条
      openUndata: false, //是否展示上传视频
      labelName: "添加分类", //编辑或者添加分类时顶部totle
      labelNameID: "", //编辑的ID
      Classification: "", //新增或者编辑的时候所输入的名称
      ClassificationBool: false, //是否展示分类的弹框
      ClassificationDel: false, //是否展示删除的弹框
      ClassTwoDel: false, //是否展示第二层删除弹框
      Deleteradio: "" //删除弹框选中的值
    };
  },
  created() {
    this.capacity({ token: this.getToken }).then(res => {
      if (res.code == 1) {
        if (res.data.total < 1024) {
          this.TotalCapacity = res.data.total + "B";
        } else if (res.data.total / 1024 < 1024) {
          this.TotalCapacity = res.data.total / 1024 + "KB";
        } else if (res.data.total / 1024 / 1024 < 1024) {
          this.TotalCapacity = res.data.total / 1024 / 1024 + "MB";
        } else if (res.data.total / 1024 / 1024 / 1024 < 1024) {
          this.TotalCapacity = res.data.total / 1024 / 1024 / 1024 + "GB";
        }
        if (res.data.used < 1024) {
          this.CurrentCapacity = res.data.used.toFixed(2) + "B";
        } else if (res.data.used / 1024 < 1024) {
          this.CurrentCapacity = (res.data.used / 1024).toFixed(2) + "KB";
        } else if (res.data.used / 1024 / 1024 < 1024) {
          this.CurrentCapacity = (res.data.used / 1024 / 1024).toFixed(2) + "MB";
        } else if (res.data.used / 1024 / 1024 / 1024 < 1024) {
          this.CurrentCapacity = (res.data.used / 1024 / 1024 / 1024).toFixed(2) + "GB";
        }
        this.percentage = (res.data.used / res.data.total) * 100;
      } else {
        this.$message.error(res.msg);
      }
    });
  },
  mounted() {
    this.GetGroupList();
    this.GetListCon();
  },
  computed: {
    ...mapGetters(["getToken"])
  },
  methods: {
    ...mapActions({
      capacity: "Content/capacity", //获取容量
      GetContentList: "Content/GetContentList", //获取素材中心的列表
      Deteleitem: "Content/Deteleitem", //删除素材中心的接口
      Publishing: "Content/Publishing", //发布和撤销发布接口
      GroupList: "Content/GroupList", //获取分组接口
      AddGroupList: "Content/AddGroupList", //新增分组接口
      EditGroupList: "Content/EditGroupList", //编辑分组接口
      DeteGroupList: "Content/DeteGroupList" //删除分组的接口
    }),
    GetGroupList() {
      let data = {
        token: this.getToken
      };
      this.GroupList(data).then(res => {
        if (res.code === 1) {
          this.classificaList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleUndoPublishing(row) {
      //撤销发布事件
      let data = {
        token: this.getToken,
        status: 2, //1-发布 2-撤销发布
        id: row.id
      };
      this.Publishing(data).then(res => {
        if (res.code === 1) {
          this.$message.success("撤销成功");
          this.GetListCon();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleRelease(row) {
      //发布事件
      let data = {
        token: this.getToken,
        status: 1, //1-发布 2-撤销发布
        id: row.id
      };
      this.Publishing(data).then(res => {
        if (res.code === 1) {
          this.$message.success("发布成功");
          this.GetListCon();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDetail(row) {
      //素材中心编辑事件
      this.$refs.upDataef.outerVisible = true;
      this.$refs.upDataef.Dotitle = "编辑视频";
      this.$refs.upDataef.Edit(row);
    },
    handleDelet(item) {
      //删除素材中心的事件
      let data = {
        token: this.getToken,
        id: item.id
      };
      this.Deteleitem(data).then(res => {
        if (res.code === 1) {
          this.GetListCon();
          this.$message.success("删除成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClick(row) {
      //素材中心查看事件
      this.$refs.upDataef.outerVisible = true;
      this.$refs.upDataef.disabled = false;
      this.$refs.upDataef.Dotitle = "详情";
      this.$refs.upDataef.details(row);
    },
    GetListCon() {
      //获取素材中心的列表
      let data = {
        token: this.getToken,
        page: this.page,
        size: this.limit
      };
      this.GetContentList(data).then(res => {
        if (res.code === 1) {
          this.tableData = res.data.list;
          this.total = res.data.count;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    NoClassTwoDelClick() {
      //删除分类二层的确定按钮
      this.ClassTwoDel = false;
    },
    ClassTwoDelClick() {
      //删除分类二层的确定按钮
      let data = {
        type: this.Deleteradio,
        token: this.getToken,
        id: this.labelNameID
      };
      this.Deteleitem(data).then(res => {
        if (res.code == 1) {
          this.ClassTwoDel = false;
          this.ClassificationDel = false;
          this.$message.success("删除成功");
          this.GetGroupList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    NoClassDeletClick() {
      //删除分类一层的取消按钮
      this.ClassificationDel = false;
    },
    ClassDeletClick() {
      //删除分类一层的确定按钮
      if (this.Deleteradio) {
        this.ClassTwoDel = true;
      } else {
        this.$message.error("请勾选分类组");
      }
    },
    ClassificationClick() {
      //分类弹框的确定事件

      if (!this.Classification) {
        return this.$message.error("请输入分类名称");
      }
      if (this.labelName === "编辑分类") {
        let data = {
          token: this.getToken, //商家用户登录身份口令
          name: this.Classification, //分组名称
          id: this.labelNameID
        };
        this.EditGroupList(data).then(res => {
          if (res.code === 1) {
            this.GetGroupList();
            this.$message.success("修改成功");
            this.ClassificationBool = false;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        let data = {
          token: this.getToken, //商家用户登录身份口令
          name: this.Classification //分组名称
        };
        this.AddGroupList(data).then(res => {
          if (res.code === 1) {
            this.$message.success("添加成功");
            this.ClassificationBool = false;
            this.GetGroupList();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    UpdataVidoe() {
      this.openUndata = true;
      this.$refs.upDataef.outerVisible = true;
      this.$refs.upDataef.Dotitle = "上传视频";
      this.$refs.upDataef.disabled = false;
    },
    GetVideoList() {
      let params = {};
    },
    handleSizeChange(value) {
      this.page = value;
      this.GetVideoList();
    },
    sizeChange(value) {
      //修改每页条数事件
      this.limit = value;
      this.GetVideoList();
    },
    AddClassit() {
      this.labelName = "添加分类";
      this.ClassificationBool = true;
      this.Classification = "";
    },
    append(value) {
      if (value == "编辑") {
        this.ClassificationBool = true;
        this.labelName = "编辑分类";
      }
      if (value == "删除") {
        this.ClassificationDel = true;
      }
    },
    handleCommand(val) {
      this.Classification = val.name;
      this.labelNameID = val.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  background-color: #fff;
  padding: 10px 12px;
}
.main {
  padding: 0px 12px;
  padding-top: 8px;
  .ContentTitle_box {
    background-color: #fff;
    padding: 12px;
    .ContentTitle {
      padding: 12px 22px;
      background-color: #f7f7f7;
      border-radius: 9px;
      .ContentTitle_name {
        width: 80px;
        text-align: right;
        font-size: 14px;
        color: #333;
        font-weight: 600;
      }
      .TotalCapacity {
        margin-top: 14px;
        font-size: 12px;
        width: 120px;
        text-align: right;
      }
      .CurrentCapacity {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 12px;
        margin-bottom: 17px;
      }
    }
  }
}
.ification_box {
  margin-top: 9px;
  margin-left: 24px;
  .ification {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #e9e9e9;
  }
}

.ContentTitle_Bot {
  min-height: 300px;
  margin-top: 3px;
  display: flex;
  .ContentTitle_Left {
    flex: 1;
    margin-right: 3px;
    background-color: #fff;
    padding: 25px 37px;
    .Video_ification {
      width: 80px;
      text-align: right;
      font-size: 14px;
      color: #333;
      font-weight: 600;
      margin-bottom: 15px;
    }
  }
  .ContentTitle_right {
    flex: 5;
    background-color: #fff;
    .page {
      margin-top: 30px;
      width: 100%;
      text-align: center;
    }
  }
}
::v-deep .el-progress-bar__outer {
  background-color: rgba($color: #2448ff, $alpha: 0.2);
}
.el-dropdown-link {
  width: 20px;
  transform: rotate(90deg);
  -ms-transform: rotate(90deg); /* Internet Explorer 9*/
  -moz-transform: rotate(90deg); /* Firefox */
  -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
  -o-transform: rotate(90deg); /* Opera */
}
</style>
